import { getJson, postJson, patchJson } from './fetch';
// import localForage from 'localforage';
// import './api-mock';

const apiBase = process.env.REACT_APP_API_BASE;

export const getTestMessage = () =>
  getJson({
    path: `${apiBase}/example`
  });

export const getRestaurants = payload =>
  getJson({
    path: `${apiBase}/examples/restaurants`,
    payload
  });

export const getRestaurant = ({ _id }) =>
  getJson({
    path: `${apiBase}/examples/restaurants/${_id}`
  });

export const patchRestaurant = ({ _id, values }) =>
  patchJson({
    path: `${apiBase}/examples/restaurants/${_id}`,
    payload: values
  });

export const getCuisines = payload =>
  getJson({
    path: `${apiBase}/examples/restaurants/lookups/cuisines`
  });

export const getMusic = payload =>
  getJson({
    path: `${apiBase}/examples/music`,
    payload
  });

export const getAlbum = payload =>
  getJson({
    path: `${apiBase}/examples/music/albums/${payload.id}`
  });

export const patchAlbum = ({ id, values }) =>
  patchJson({
    path: `${apiBase}/examples/music/albums/${id}`,
    payload: values
  });

export const getArtists = payload =>
  getJson({
    path: `${apiBase}/examples/music/artists`,
    payload
  });

export const getAuditLog = () =>
  getJson({
    path: `${apiBase}/audit-log`
  });

export const postLogin = payload =>
  postJson({
    path: `${apiBase}/identity/login`,
    payload
  });

export const getContent = ({ page, preview }) =>
  getJson({
    path: `${apiBase}/content/${page}?preview=${preview || ''}`
  });

export const getKnowledgeCenterArticles = () =>
  getJson({
    path: `${apiBase}/content/knowledge-center`
  });

export const checkLoginStatus = ({ cookie }) =>
  getJson({
    path: `${apiBase}/identity/login-status?cookie=${encodeURIComponent(cookie)}`
  });

export const forgotPassword = payload =>
  postJson({
    path: `${apiBase}/identity/forgot-password`,
    payload
  });

export const resetPassword = payload =>
  postJson({
    path: `${apiBase}/identity/reset-password`,
    payload
  });

export const postContactForm = payload =>
  postJson({
    path: `${apiBase}/contact`,
    payload
  });



// WEBPACK FOOTER //
// ./src/api/api.js